module.exports = {
	"shared.crew.original-music-composer": "Compositore Musicale",
	"social-button.twitter": "Twitter",
	"shared.crew.publicist": "Pubblicista",
	"share-overlay.share": "Condividi questo video",
	"shared.crew.associate-producer": "Produttore Associato",
	"shared.crew.assistant-editor": "Assistente dell'Editor",
	"overlay.buy-from": "Acquisto a {price}",
	"shared.crew.agent": "Agente",
	"shared.crew.additional-photography": "Fotografo",
	"shared.crew.sound-editor": "Editore del Suono",
	"shared.crew.print-shipper": "Print Shipper",
	"shared.crew.hairstylist": "Parrucchiere",
	"shared.crew.makeup-effects": "Effetti Makeup",
	"social-button.pinterest": "Pinterest",
	"shared.crew.production-assistant": "Assistente di Produzione",
	"shared.crew.executive-producer": "Produttore Esecutivo",
	"shared.crew.costumer": "Costumista",
	"info-overlay.cast": "cast",
	"shared.crew.stunt-coordinator": "Coordinatore Stunt",
	"shared.crew.academic-advisor": "Consulente Didattico",
	"shared.crew.swing-gang": "Addetto Smontaggio",
	"shared.crew.best-boy": "Elettricista",
	"actions.purchased": "Questo video è tuo adesso",
	"social-button.tumblr": "Tumblr",
	"quality.format": "{qualityValue}p",
	"shared.crew.set-decorator": "Decoratore del Set",
	"shared.crew.adaptation": "Adattamento",
	"shared.crew.school-administrator": "Dirigente Scolastico",
	"shared.crew.cable-person": "Addetto sistemaz. cavi",
	"shared.crew.digital-effects": "Effetti Digitali",
	"actions.rent": "Noleggio {price}",
	"info-overlay.created-by": "Da {author}",
	"social-share.twitter": "Guarda \"{title}\" su {siteUrl}",
	"shared.crew.production-designer": "Disegno di Produzione",
	"info-overlay.crew": "troupe",
	"shared.crew.producer": "Produttore",
	"shared.crew.2nd-unit-dir-of-photography": "2° Fotografo di Scena",
	"shared.crew.special-effects": "Effetti Speciali",
	"actions.rented": "Noleggiato da {date}",
	"shared.crew.boom-operator": "Microfonista",
	"shared.crew.story": "Trama",
	"shared.crew.script-supervisor": "Segretario di Edizione",
	"shared.crew.director": "Regista",
	"shared.crew.choreographer": "Coreografo",
	"shared.crew.production-manager": "Manager di Produzione",
	"quality.auto": "Auto",
	"shared.crew.lead-person": "Lead Person",
	"shared.crew.location-manager": "Manager della Location",
	"shared.crew.costume-designer": "Stlista",
	"fullscreen.exit": "Esci da schermo intero",
	"shared.crew.technical-advisor": "Consulente Tecnico",
	"shared.crew.editor": "Editor",
	"shared.crew.additional-grip": "Macchinista ",
	"actions.buy": "Acquisto {price}",
	"shared.crew.assistant-camera": "Assistente Operatore",
	"shared.crew.writer": "Sceneggiatore",
	"social-share.pinterest": "{title} - {description}",
	"shared.crew.collaborating-director": "Regista Collaboratore",
	"fullscreen.enter": "Schermo intero",
	"shared.crew.animal-trainer": "Addestratore animale",
	"shared.crew.assistant-art-director": "Assistente Direttore Artistico",
	"shared.crew.key-grip": "Capo Cameraman",
	"social-button.copy": "Copia",
	"shared.crew.makeup-artist": "Makeup Artist",
	"overlay.source-error": "Il video non può essere riprodotto",
	"social-button.link": "Link",
	"actions.buy-from": "Acquista a {price}",
	"shared.crew.art-director": "Direttore artistico",
	"shared.crew.production-coordinator": "Coordinatore di Produzione",
	"shared.crew.co-director": "Co-Regista",
	"shared.crew.co-producer": "Co-Produttore",
	"shared.crew.video-operator": "Operatore Video",
	"shared.crew.camera-operator": "Operatore di camera",
	"shared.crew.co-writer": "Co-Sceneggiatore",
	"shared.crew.set-designer": "Designer del Set",
	"shared.crew.preview-return": "Preview Return",
	"shared.crew.property-master": "Trovarobe",
	"shared.crew.cinematographer-dp": "Cinematografo/DP",
	"shared.crew.grip": "Macchinista",
	"social-share.tumblr": "{title} - {siteUrl}",
	"shared.crew.sound-mixer": "Mixer del Suono",
	"quality.label": "Qualità",
	"social-button.facebook": "Facebook",
	"shared.crew.gaffer": "Tecnico delle luci",
	"shared.crew.assistant-director": "Assistente di Regia",
	"actions.subscribe": "Iscriviti per {price}/mese",
	"shared.crew.print-return": "Print Return",
	"shared.crew.animator": "Animatore",
	"shared.crew.dolly-grip": "Carrellista",
	"shared.crew.manager": "Manager",
	"shared.crew.2nd-assistant-director": "2° Assistente di Regia",
	"shared.crew.author-of-adapted-material": "Autore del materiale adattato"
};


//////////////////
// WEBPACK FOOTER
// ./src/widget/player-widget/translations/widget-texts_it.json
// module id = 2790
// module chunks = 66